import { typography } from '../theme';

import { ResponsiveSizes } from './responsive';

const rootFontSize = 16;

const round = (value: number, dp = 0): number => {
  const multiplier = Math.pow(10, dp);

  return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
};

export const pxToRem = (x: number): string =>
  `${round(x / typography.baseFontSize, 2)}rem`;

export const pxToEm = (x: number): string => `${round(x / rootFontSize, 2)}em`;

const modularScaleValue = (step: number): number =>
  Math.pow(1.2, step) * typography.baseFontSize;

interface ModularScaleFunction {
  (step?: number): string;
  (responsiveSizes: ResponsiveSizes): ResponsiveSizes;
}

export const modularScale: ModularScaleFunction = (
  step: number | ResponsiveSizes = 0
): any =>
  typeof step === 'number'
    ? pxToRem(modularScaleValue(step))
    : {
        mobile: modularScaleValue(step.mobile),
        desktop: modularScaleValue(step.desktop),
      };
